import React from 'react';
import { Typography } from '@fiverr-private/typography';
import { Alert, AlertTitle, AlertText } from '@fiverr-private/feedback';
import { appTranslate } from '../../i18n';

export const SubscriptionEligibilityAlert = () => (
    <Alert variant="error">
        <AlertTitle>{appTranslate('alerts.subscription_eligibility.title')}</AlertTitle>
        <AlertText>
            <Typography fontSize="b_sm">{appTranslate('alerts.subscription_eligibility.description')}</Typography>
        </AlertText>
    </Alert>
);
